export default __webpack_public_path__ + "static/media/warehouse-dark.7a7db05d.svg";